import { useQuery } from '@tanstack/react-query'
import { api } from '../../api'

export interface CalendarMed {
  id: number
  name: string
  color: string
  frequency?: string | null
}

export interface CalendarPainEntry {
  id?: number
  pain_score: number
  pain_character?: string[] | null
  notes?: string | null
  created_at?: string | null
}

export interface CalendarPainDay {
  pain_score: number | null
  pain_character?: string[] | null
  pain_locations?: string[] | null
  notes?: string | null
  zero_filled?: boolean
  entries?: CalendarPainEntry[]
}

export interface CalendarTrackingDay {
  cycle_phase?: string | null
  period_flow?: string | null
  symptoms?: string[] | null
  sleep_hours?: number | null
  stress_level?: number | null
  energy_level?: number | null
  food_tags?: string[] | null
  alcohol?: string | null
  cervical_mucus?: string | null
  flow_products_count?: number | null
  pads_count?: number | null
  tampons_count?: number | null
  notes?: string | null
  period_starting?: boolean
}

export interface AdherenceStat {
  id: number
  name: string
  color: string
  frequency?: string | null
  pct: number
  uses?: number
}

export interface CalendarResponse {
  medications: CalendarMed[]
  pain_map: Record<string, CalendarPainDay>
  adherence_map: Record<string, Record<string, boolean>>
  tracking_map: Record<string, CalendarTrackingDay>
  adherence_stats: AdherenceStat[]
}

export function useCalendar(days: number) {
  return useQuery({
    queryKey: ['patient', 'calendar', days],
    queryFn: () => api.get<CalendarResponse>(`/api/patient/calendar?days=${days}`),
    staleTime: 30_000,
  })
}
